<div class="unauthorized-container">
  <mat-card color="primary"> 
    <mat-card-content>
      <mat-card-title style="color: var(--primary-color) !important;">Unauthorized access</mat-card-title>
      <mat-divider></mat-divider>
      <mat-card-content style="min-height: 100px;">
        <p>You do not have permission to access this page.</p>
      </mat-card-content>
    </mat-card-content>
    <div class="flex-justify w-100">
      <button mat-raised-button (click)="goToLogin();"><mat-icon>login</mat-icon>Login</button>
      <button mat-flat-button (click)="goBack();"><mat-icon>backspace</mat-icon>Back</button>
    </div>
  </mat-card>
</div>